module.exports = __webpack_public_path__ + "img/docma-logo-reversed.d57aaa4d.svg";